import React, { useState, useEffect, useContext, useRef } from "react";
import Box from "@mui/material/Box";
import axios from "axios";
import "../../style.css";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { useSelector } from "react-redux";
import LinkIcon from '@mui/icons-material/Link';
import { useNavigate, Link, useParams } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { SetredirectValue } from "../../../../Store/PageredirectSlice";
import { Helmet } from 'react-helmet';
import { ToastContainer, toast } from 'react-toastify';
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Rightsidebar from "../../Rightsidebar/Rightsidebar";
import { AppContext } from "../../../../Context/Context";
import { Commonfun, timezonechange, timezoneval } from "../../../NavBar/Commonfun";
import { Utils } from "../../../../Utils/Utils";
import Freeaudit from "../../../../Utils/Freeaudit";
import Loader from "../../CommonLoader";
import CommonAlert from "../../../../Commonalert/commonalert";
import DatagridComp from "../../DatagridComp";
// import PdfandCsv from "../PdfandCsv";
import CommonBreadCrumb from "../../../../Commonalert/commonbreadcrumb";
import { Container, Grid, Tooltip } from '@mui/material';
import { customDropdownStyles } from "../../../../Commonalert/commonDropdown";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "react-select";
import { CommonErrorAlert } from "../../../../Commonalert/commonErrorAlert";
import UserActivityTracker from "../../../../hooks/userActivityTracker";

export default function VulnerabilityDetail() {

    const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
    const [cardData, setCardData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [jobDate, setjobDate] = useState("");
    const [notifycount, setNotifycount] = useState("");
    const [topActionItemPlan, settopActionItemPlan] = useState({ status: true, error: "" });
    const [isDownloading, setIsDownloading] = useState(false);
    const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);

    const esodata = useSelector((state) => state);
    const ApiToken = esodata.apiauthkey.value
    const [autoheightval, SetAutoheightval] = useState(true)
    const [faqData, setfaqData] = useState("2")
    const [toggle, setToggle] = useState(false);
    const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
    const [apiopen, setapiOpen] = React.useState(false);
    const [apierrorMsg, setapierrorMsg] = useState();
    const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
    const [tableLoading, setTableLoading] = useState(true);
    const [isTracePopup, setIsTracePopup] = useState(false);
    const [trace, setTrace] = useState('');

    const navigate = useNavigate();

    let querystring = useParams();
    const ItemId = querystring.id;
    const issueType = querystring.issueType;

    const checkUserPlan = async () => {
        // const topActionItemP = await Utils("top_action_items", ApiToken);
        const topActionItemP = { status: true, error: "" };
        if (topActionItemP.status) {
            callUserdataApi();
            faqdatafun();
        }
        settopActionItemPlan(topActionItemP);
    };

    useEffect(() => {
        checkUserPlan();
    }, []);

    const columns = [
        {
            field: "url",
            headerName: "URL",
            description: 'The URL associated with the security issue.',
            minWidth: 200,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: true,
            renderCell: (cardData) => {
                let baseUrl =
                    cardData.row.url.split("/").slice(0, 3).join("/") + "/";
                let remaining = cardData.row.url.split("/").slice(3).join("/");
                return (
                    <>
                        <Tooltip title={cardData.row.url}>
                            <div className="prefered_url_external02">
                                <a
                                    target="_blank"
                                    href={cardData?.row?.url}
                                    style={{ display: "flex", flexDirection: "column" }}
                                >
                                    <span className="spanlink">
                                        <LinkIcon /> {baseUrl}
                                    </span>
                                    <span
                                        className="spanlink"
                                        style={{
                                            color: "#044792",
                                            wordWrap: "break-word",
                                            wordBreak: "break-word",
                                        }}
                                    >
                                        {remaining}
                                    </span>
                                </a>
                            </div>
                        </Tooltip>
                    </>
                );
            },
        },
        {
            field: "memo",
            headerName: "Memo",
            description: 'Additional notes or comments related to the issue.',
            minWidth: 200,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: true
        },
        {
            field: "Action",
            headerName: "Action",
            description: 'Click to view the detailed report',
            minWidth: 130,
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
            headerClassName: "hide_option",
            renderCell: (cardData) => {
                return (
                    <div style={{ justifyItems: "center" }}>
                        <button className="view-report-button" onClick={() => { setTrace(cardData.row.trace); setIsTracePopup(true); }}>View Report</button>
                    </div>
                );
            },
        },
    ];

    const columns1 = [
        {
            field: "issue_name",
            headerName: "Issue Name",
            description: 'The name or title of the security issue detected in the audit.',
            minWidth: 200,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: true
        },
        {
            field: "issue_type",
            headerName: "Issue Type",
            description: 'The severity level of the security issue, ',
            minWidth: 200,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: true
        },
        {
            field: "memo",
            headerName: "Memo",
            description: 'Additional notes or comments related to the issue.',
            minWidth: 200,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: true
        },
        {
            field: "Action",
            headerName: "Action",
            description: 'Click to view the detailed report',
            minWidth: 130,
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
            headerClassName: "hide_option",
            renderCell: (cardData) => {
                return (
                    <div style={{ justifyItems: "center" }}>
                        <button className="view-report-button" onClick={() => { setTrace(cardData.row.trace); setIsTracePopup(true); }}>View Report</button>
                    </div>
                );
            },
        },
    ];

    const rows = cardData ?? [];


    const callUserdataApi = async (jobId = "") => {
        setLoading(true);
        setTableLoading(true);

        const datavalue = await axios.get(
            `${process.env.REACT_APP_API_URL}security_tools/vulnerability_detail_report/?id=${ItemId}&type=${issueType}&formats=&timezone=${timezoneval()}&user_domain_id=${esodata.domaindata.value.header_selected}`, {
            headers: {
                Authorization: `${ApiToken}`,
            },
        }
        ).catch((error) => {
            if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
                setapiOpen(true);
                if (error?.response?.data?.security_config) {
                    const securityError = <div dangerouslySetInnerHTML={{ __html: error?.response?.data?.security_config }} />
                    setapierrorMsg(securityError);
                } else {
                    setapierrorMsg(error?.response?.data?.error)
                }
            }
            else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
                navigate('/errorpages')
            }
        });
        if (datavalue?.data && datavalue?.data?.length > 0) {
            const jobD = datavalue?.data.pop();
            const dataval = datavalue?.data;
            setjobDate(moment(jobD.job_date).format("MMMM DD,YYYY HH:mm"));
            SetAutoheightval(false)

            const newData = dataval.map((obj, index) => {
                return { ...obj, sid: index + 1 };
            });
            setCardData(newData);
        }
        else {
            SetAutoheightval(true)
            setCardData("");
        }

        setTableLoading(false);
        setLoading(false);
    };


    const pdfdown = async () => {

        setLoading(true);
        setIsDownloading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}security_tools/vulnerability_detail_report/?id=${ItemId}&type=${issueType}&formats=pdf&timezone=${timezoneval()}&user_domain_id=${esodata.domaindata.value.header_selected}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/pdf',
                    Authorization: `${ApiToken}`,
                },
            });

            if (response.ok) {

                const blob = await response.blob();


                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                var filedata = await Commonfun("vulnerabilityaudit", "pdf", ApiToken, esodata.domaindata.value.header_selected);
                link.download = filedata;
                link.click();


                window.URL.revokeObjectURL(link.href);
            } else {
                if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
                    response.json().then(data => {
                        setapiOpen(true);
                        setapierrorMsg(data?.error)
                    })
                }
                else if (response?.code == "ERR_NETWORK") {
                    navigate('/errorpages')
                }
            }
        } catch (error) {
            toast.error("No Data", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            console.error('Error during PDF download:', error);
        }
        setLoading(false);
        setIsDownloading(false);


    }

    const csvdown = async () => {
        setLoading(true);
        setIsDownloadingcsv(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}security_tools/vulnerability_detail_report/?id=${ItemId}&type=${issueType}&formats=csv&timezone=${timezoneval()}&user_domain_id=${esodata.domaindata.value.header_selected}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/pdf',
                    Authorization: `${ApiToken}`,
                },
            });
            if (response.ok) {
                const blob = await response.blob();
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'vulnerabilityaudit.csv';

                link.click();


                window.URL.revokeObjectURL(link.href);
            } else {
                if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
                    response.json().then(data => {
                        setapiOpen(true);
                        setapierrorMsg(data?.error)
                    })
                }
                else if (response?.code == "ERR_NETWORK") {
                    navigate('/errorpages')
                }
            }
        } catch (error) {
            toast.error("No Data", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            console.error('Error during PDF download:', error);
        }
        setLoading(false);
        setIsDownloadingcsv(false);

    }

    const faqdatafun = async (menubutval = "") => {
        var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=41`

        try {
            const doaminsectiondatavalue = await axios.get(
                datavar,
                {
                    headers: {
                        Authorization: `${ApiToken}`,
                    },
                }
            ).catch((error) => {
                if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
                    setapiOpen(true);
                    setapierrorMsg(error?.response?.data?.error)
                }
                else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
                    navigate('/errorpages')
                }
            });
            if (doaminsectiondatavalue?.data) {
                SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
            }
        } catch (err) { }
    }

    const handleDownlodingCSV = () => {
        csvdown();
    }

    const handleDownlodingPDF = () => {
        pdfdown();
    }

    const apihandleClose = () => {
        setapiOpen(false);
    };

    const closeTracePopup = () => {
        setIsTracePopup(false);
    }


    return (
        <div className={`over_all_container top_action_list ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Vulnerability Audit</title>
            </Helmet>

            {loading === true ? <Loader /> : null}

            <Container maxWidth={false} className="dashboard-container">
                <Box className="dashboard-box">
                    <Grid container className="dashboard-grid">
                        <Grid item xs={12} md={4}>
                            <div>
                                <h1 className="dashboard_header">
                                    Vulnerability Detail
                                    {/* <span className="faq-chip" onClick={handleToggle}>FAQ's</span> */}
                                </h1>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <div className="top_breadcrumb_menu">
                                <div className="exportpdf_outer">
                                    <div className="breadcrumb-wrapper">
                                        <CommonBreadCrumb breadcrumbValue={[
                                            { title: 'Security Tools', activeColor: false },
                                            { title: 'Vulnerability Audit', link: '/vulnerabiity-audit', activeColor: true },
                                            { title: 'Vulnerability Detail', activeColor: true }
                                        ]} />
                                    </div>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </Container>

            <Container maxWidth={false} className="dashboard-container">
                <Box className="dashboard-box-time">
                    <Grid container className="dashboard-grid">
                        <Grid item xs={12} md={6}>
                            <div className="time_zone">
                                <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                                <span className="timezone-val">{timezoneval()}</span>
                            </div>
                        </Grid>

                        <Grid item xs={12} md={6}>
                        </Grid>
                    </Grid>
                </Box>
            </Container>

            <Container maxWidth={false} className="dashboard-container">
                <Box className="grid_table_shodow">
                    <Grid container className="dashboard-grid">
                        <Grid item xs={12} md={12}>
                            <div className="cnt_audit_outer_wrap">
                                {topActionItemPlan.status ?
                                <>
                                    <DatagridComp className="datagrid_custom_scroll"
                                        columns={issueType === 'url' ? columns1 : columns}
                                        rows={rows}
                                        autoheightval={autoheightval}
                                        datagridval={2}
                                        columnFreezeWidth={[0]}
                                        tableLoading={tableLoading}
                                        // handleModelPopUp={handleModelPopUp}
                                        handleDownlodingCSV={handleDownlodingCSV}
                                        handleDownlodingPDF={handleDownlodingPDF}
                                        customFilter={false}
                                        DownloadShowFile={true}
                                        DownloadShowPDF={1}
                                        DownloadShowCSV={2}
                                    />
                                      
                                          <UserActivityTracker pagename="Security Tools - Vulnerability Audit - Vulnerability Detail" />
                                    </>
                                    : <Freeaudit planStatus={topActionItemPlan} />
                                }
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </Container>

            <Container maxWidth={false} className="footer-container">
                <Box className="footer-box">
                    <Grid container className="footer-grid">
                        <Grid item xs={12} md={6}>
                            <div className="footer-left">
                                <p className="footer-text">
                                    All Rights Reserved Copyright © 2026 |
                                    <a href="https://www.elitesiteoptimizer.ai/" target="_blank"> <span className="footer-brand"> Elite site Optimizer</span></a>
                                </p>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <div className="footer-right">
                                <p>{/* Add content if needed */}</p>
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </Container>

            <div className="cnt_audit_outer_wrap">
                <div >
                    {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}

                </div>
                <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
            </div>

            <Dialog
                open={isTracePopup}
                onClose={closeTracePopup}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="competitor_test_filter job_date_filter over_all_accessibility"
            >
                <DialogTitle className="keyword-dialog-header ">
                    {"Trace Data"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        <div style={{ maxHeight: "300px", overflowY: "auto", wordBreak: "break-all" }}>
                            {trace}
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="dialog-action-button">
                    <button style={{ cursor: "pointer" }} onClick={closeTracePopup}>
                        Close
                    </button>
                </DialogActions>
            </Dialog>

            <CommonErrorAlert
                data={{
                    apiopen: apiopen,
                    apiErrorMsg: apierrorMsg,
                    isIconStyled: true
                }}
                closeAlert={apihandleClose} />

        </div>
    );
}
